import React from 'react'
import { Commodity } from '@/hooks'
import CommodityBadge from '@/components/molecules/CommodityBadge/CommodityBadge'

interface CommodityBadgeListProps {
    commodities: Commodity[]
}

const CommodityBadgeList: React.FC<CommodityBadgeListProps> = ({
    commodities,
}) => {
    return (
        <div className="flex flex-wrap gap-2">
            {commodities.map((commodity) => (
                <CommodityBadge
                    key={commodity.commodityTypeId}
                    label={commodity.commodityName}
                    commodityTypeId={commodity.commodityTypeId}
                />
            ))}
        </div>
    )
}

export default CommodityBadgeList
